import { Dispatch, SetStateAction } from 'react';
import { TranslateFn } from '../../../hooks/context/useTranslate';
import { FilterError } from '../../../types/types';
import { translatedToast } from '../../../utils/helpers';
import { createFlattenedFormItemsArray } from './createFlattenedFormItemsArray';
import { validateFormItem } from './validateFormItem';

export const validateSubmitData = (
  t: TranslateFn,
  formData: Record<string, any>,
  formItems: any[],
  formErrors: Record<string, FilterError>,
  setFormErrors: Dispatch<SetStateAction<Record<string, FilterError>>>,
  isMounted?: (name: string) => boolean
): boolean => {
  const flattenedFormItems = createFlattenedFormItemsArray(formItems);
  let isValid = true;

  const newState: Record<string, FilterError> = { ...formErrors };

  flattenedFormItems.forEach((item) => {
    if (!item.visible) return;
    if (isMounted && !isMounted(item.name)) return;
    if (formErrors[item.name]) {
      isValid = false;
      return;
    }
    const error = validateFormItem(item, formData[item.name], t);
    if (error) {
      newState[item.name] = error;
      isValid = false;
      return;
    }
  });
  if (!isValid) {
    translatedToast('errors.checkAllFields');
  }
  setFormErrors(newState);

  return isValid;
};
